module.exports = __webpack_public_path__ + "img/5.96353f40.jpg";